import { axiosPrivate } from "../../services/makeRequest"

export function saveDeviceToken({ token, accessToken }) {
    return axiosPrivate("/users/device-token", {
        method: "PATCH",
        data: { device_token: token },
        headers: { Authorization: `Bearer ${accessToken}` },
    })
        .then((res) => res.data)
        .catch((error) => {
            console.error("Failed to save device token:", error)
        })
}
